import Muvue from '@mapit/muvue'
import Vue from 'vue'

Vue.use(Muvue)
